import React from "react";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  IconButton,
  Button,
  Paper,
} from "@mui/material";
import { useEntidade } from "../../Hooks/EntidadeHook";
import { useUsuario } from "../../Hooks/UsuarioHook";
import { useNavigate } from "react-router-dom";
import { app_base_url } from "../../Utils/Urls";
import { useUsuarioPrefeitura } from "../../Hooks/UsuarioPrefeituraHook";
import { useUsuarioNaoEmiteNota } from "../../Hooks/UsuarioNaoEmiteNotaHook";
import theme from "../../Styles/theme";

export function Header() {
  const { entidade } = useEntidade();
  const { logOut } = useUsuario();
  const { logoutP } = useUsuarioPrefeitura();
  const { logoutUsuarioNaoEmiteNota } = useUsuarioNaoEmiteNota();
  const navigate = useNavigate();

  const handleLogout = () => {
    logOut();
    logoutP();
    logoutUsuarioNaoEmiteNota();
    window.location.reload();
  };

  return (
    <Paper
      elevation={2}
      sx={{
        width: "95vw",
        margin: "auto",
        borderBottom: "2px solid #ccc",
        borderRadius: 0,
      }}
    >
      <AppBar
        position="static"
        elevation={0}
        sx={{
          backgroundColor: theme.colors.secondary,
          color: theme.colors.dark,
          boxShadow: "none",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-around", width: "100%" }}>
          {/* Logo */}
          <IconButton onClick={() => window.open(entidade.portal)}>
            <img src={entidade.logo} alt="Logo" width="80" />
          </IconButton>

          {/* Título + Subtítulo */}
          <Box
            textAlign="center"
            onClick={() => navigate(`${app_base_url}/${entidade.banco}`)}
            sx={{ cursor: "pointer" }}
          >
            <Typography variant="h6" fontWeight="bold">
              ISS
            </Typography>
            <Typography variant="body2">
              Sistema de geração e gerenciamento de guias de ISS
            </Typography>
          </Box>

          {/* Botão SAIR vermelho */}
          <Button
            variant="outlined"
            onClick={handleLogout}
            sx={{
              color: "#d32f2f",
              borderColor: "#d32f2f",
              "&:hover": {
                backgroundColor: "#fddede",
                borderColor: "#d32f2f",
              },
            }}
          >
            SAIR
          </Button>
        </Toolbar>
      </AppBar>
    </Paper>
  );
}
